require('../../modules/es6.array.fill');
module.exports = require('../../modules/_core').Array.fill;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/array/fill.js
// module id = 674
// module chunks = 0